<div class="auth-wrapper">
  <div class="auth">
    <rx-icon name="RxPhoto-light" size="127" class="app-logo"></rx-icon>
    <mat-card class="container">
      <mat-card-content class="section">
        <div class="flex">
          <div class="header">
            <div class="forgot-title">{{ title }}</div>
            <div class="error-title" *ngIf="loginError">
              {{ loginError }}
            </div>
          </div>
          <div class="flex jcsb">
            <router-outlet></router-outlet>
          </div>
        </div>
      </mat-card-content>
    </mat-card>
    <div class="flex flex-nosize aic mt16 forgot">
      <a
        role="button"
        tabindex="0"
        (click)="backToLogin()"
        (keydown.enter)="backToLogin()"
        (keydown.space)="backToLogin()"
      >
        Back to RxPhoto login
      </a>
    </div>
  </div>

  <div class="auth-right">
    <ads-banner #adsBanner></ads-banner>
  </div>
</div>

<div class="privacy">
  <div class="privacy-content">
    <div class="privacy-links">
      <a href="https://www.patientnow.com/privacy-policy/" class="privacy-link" target="_blank">Privacy</a>
      <a href="https://www.patientnow.com/terms-of-service/" class="privacy-link" target="_blank">Terms</a>
      <a href="https://www.patientnow.com/privacy-policy/#Cookies" class="privacy-link" target="_blank"> Cookies </a>
    </div>
    <p>Copyright © {{ currentYear }} PatientNow LLC. All rights reserved.</p>
  </div>
</div>
